{
"catalog": {
" company has been added": " une entreprise a \u00e9t\u00e9 ajout\u00e9e",
" day. Renew now to continue enjoying uninterrupted access.": " jour. Renouvelez d\u00e8s maintenant pour continuer \u00e0 profiter d'un acc\u00e8s ininterrompu.",
" days. Renew now to continue enjoying uninterrupted access.": " jours. Renouvelez d\u00e8s maintenant pour continuer \u00e0 profiter d'un acc\u00e8s ininterrompu.",
"(\u00d8re/kWh)": "(\u00d8re/kWh)",
"0.00": "0.00",
": The new company has been added": ": La nouvelle entreprise a \u00e9t\u00e9 ajout\u00e9e",
"A code of reference ( Who referred a company)": "Un code de r\u00e9f\u00e9rence (qui a r\u00e9f\u00e9renc\u00e9 une entreprise)",
"A link has been sent to your email address to reset password": "Un lien a \u00e9t\u00e9 envoy\u00e9 \u00e0 votre adresse \u00e9lectronique pour r\u00e9initialiser votre mot de passe",
"A link has been sent to your email address to reset password.": "Un lien vous a \u00e9t\u00e9 envoy\u00e9 \u00e0 votre adresse e-mail pour r\u00e9initialiser votre mot de passe.",
"A newer version of this application is available. The update will begin automatically in 20 seconds.": "Une version plus r\u00e9cente de cette application est disponible. La mise \u00e0 jour commencera automatiquement dans 20 secondes.",
"A suspicious activity was detected. For security reasons, you must log in again": "Une activit\u00e9 suspecte a \u00e9t\u00e9 d\u00e9tect\u00e9e. Pour des raisons de s\u00e9curit\u00e9, vous devez vous reconnecter",
"API Documentation": "Documentation de l\u2019API",
"API Key": "Cl\u00e9 API",
"API key": "Cl\u00e9 API",
"Access from partner website": "Acc\u00e8s \u00e0 partir du site web du partenaire",
"Access given": "Acc\u00e8s accord\u00e9",
"Access is Required!": "L'acc\u00e8s est obligatoire !",
"Access period": "P\u00e9riode d'acc\u00e8s",
"Account Setup": "Configuration du compte",
"Account creation code": "Code de cr\u00e9ation de compte",
"Actions": "Actions",
"Active": "Actif",
"Active Users": "Utilisateurs actifs",
"Active Users List": "Liste des utilisateurs actifs",
"Add": "Ajouter",
"Add Contract": "Ajouter un contrat",
"Add Corporate Group": "Ajouter un groupe d'entreprises",
"Add Customer": "Ajouter client",
"Add Document": "Ajouter un document",
"Add Historical Data Limit": "Ajouter une limite pour les donn\u00e9es historiques",
"Add New Corporate Group": "Ajouter un nouveau groupe d'entreprises",
"Add New Feature": "Ajouter nouvelle caract\u00e9risque",
"Add New Module": "Ajouter un nouveau module",
"Add New Partner": "Ajouter un nouveau partenaire",
"Add New Subscription": "Ajouter un nouvel abonnement",
"Add New User": "Ajouter un nouvel utilisateur",
"Add Partner": "Ajouter",
"Add User": "Ajouter un utilisateur",
"Add a new role": "Ajouter un nouveau r\u00f4le",
"Add company": "Ajouter une soci\u00e9t\u00e9",
"Add contract": "Ajouter un/le contrat",
"Add feature": "Ajouter une fonctionnalit\u00e9",
"Add permission": "Ajouter une autorisation",
"Add role": "Ajouter un r\u00f4le",
"Add subscription plan": "Ajouter un plan d'abonnement",
"Address": "Adresse",
"Aggregated": "Agr\u00e9g\u00e9",
"Aggregation": "Agr\u00e9gation",
"Alias": "Alias",
"All": "Tout",
"All Documents": "Tous les documents",
"All Partners": "Tous les partenaires",
"All Users": "Tous les utilisateurs",
"All kWh": "Tous les kWh",
"All notifications deleted successfully": "Toutes les notifications ont \u00e9t\u00e9 supprim\u00e9es avec succ\u00e8s.",
"All notifications marked as read": "Toutes les notifications marqu\u00e9es comme lues",
"Alpha numeric and dash only": "Alpha, num\u00e9rique et tiret uniquement",
"Already have an account?": "Vous avez d\u00e9j\u00e0 un compte ?",
"Amount of money for consumption": "Montant de la consommation",
"An error occurred while deleting the document": "Une erreur s'est produite lors de la suppression du document.",
"An error occurred while the system was generating the report. Please try again. You can contact support If this continues.": "Une erreur s'est produite pendant que le syst\u00e8me g\u00e9n\u00e9rait le rapport. Veuillez r\u00e9essayer. Vous pouvez contacter l'assistance si le probl\u00e8me persiste.",
"An unexpected error occurred. It has been logged, and we are working on a resolution.": "Une erreur inattendue s'est produite. Elle a \u00e9t\u00e9 enregistr\u00e9e et nous travaillons \u00e0 sa r\u00e9solution.",
"Annual CO\u2082e (Kg)": "\u00c9missions annuelles de CO\u2082e (Kg)",
"Annual Statement": "D\u00e9claration annuelle",
"Annual energy consumption (kWh)": "Consommation annuelle d'\u00e9nergie (kWh)",
"App": "App",
"App URL": "URL de l'application",
"Apr": "Avr",
"Apr: Checking": "Apr : V\u00e9rification",
"Apr: Get": "Apr : Obtenir",
"Apr: Update": "Apr : Mise \u00e0 jour",
"April": "Avril",
"Are you sure you want to delete this notification ? ": "\u00cates-vous s\u00fbr de vouloir supprimer cette notification ? ",
"Are you sure you want to delete?": "Etes-vous s\u00fbr de vouloir supprimer?",
"Attach Company with User": "Joindre l'entreprise \u00e0 l'utilisateur",
"Aug": "Ao\u00fbt",
"Aug: Checking": "Aug : V\u00e9rification",
"Aug: Get": "Aug : Obtenir",
"Aug: Update": "Aug : Mise \u00e0 jour",
"August": "Ao\u00fbt",
"Authority Processing": "Traitement de l'autorit\u00e9",
"Authorization": "Autorisation",
"Availability Payment": "Disponibilit\u00e9 Paiement",
"Availability Rate": "Taux de disponibilit\u00e9",
"Back": "Retour",
"Back to": "Retour \u00e0",
"Back to Documents": "Retour aux documents",
"Basic Information": "Informations de base",
"Before getting started, could you verify your email address by ": "Avant de commencer, pourriez-vous v\u00e9rifier votre adresse \u00e9lectronique en proc\u00e9dant comme suit ",
"Blocked": "Bloqu\u00e9",
"Building": "B\u00e2timent",
"Building address": "Adresse du b\u00e2timent",
"Building is required": "La construction est n\u00e9cessaire",
"But you still need to know more.": "Mais vous avez encore besoin d'en savoir plus.",
"CAPTCHA verification failed. Please try again.": "La v\u00e9rification CAPTCHA a \u00e9chou\u00e9. Veuillez r\u00e9essayer.",
"CCPA Privacy Rights (Do Not Sell My Personal Information)": "Droits de la protection de la vie priv\u00e9e de l'ACCP (Ne pas vendre mes informations personnelles)",
"CO\u2082_per_m2": "CO\u2082_par_m2",
"CO\u2082e": "CO\u2082e",
"CO\u2082e (Kg)": "CO\u2082e (Kg)",
"CVR": "Num\u00e9ro de soci\u00e9t\u00e9 (SIREN)",
"Cached": "En cache",
"Cancel": "Annuler",
"Carbon Emissions (Kg CO\u2082e)": "\u00c9missions de carbone (kg CO\u2082e)",
"Carbon Footprint (g CO\u2082e/kWh)": "Empreinte carbone (g CO\u2082e/kWh)",
"Carbon dioxide Consumption": "Dioxyde de carbone Consommation",
"Cashed Statement - Under Development": "D\u00e9claration encaiss\u00e9e - En cours de d\u00e9veloppement",
"Central business Register number": "Num\u00e9ro du registre central des entreprises",
"Change Password": "Modifier le mot de passe",
"Change password": "Changer le mot de passe",
"Checking Cache": "V\u00e9rification du cache",
"Child Company": "Filiale",
"Child company and above level access": "Soci\u00e9t\u00e9 filiale et acc\u00e8s de niveau sup\u00e9rieur",
"City": "Ville",
"Clear above cache": "Effacer le cache",
"Clear all cache": "Vider tout les caches",
"Clear browser memory / Page reload": "Effacer la m\u00e9moire du navigateur / Recharger la page",
"Click to copy": "Cliquez pour copier",
"Click to upload or drag and drop": "Cliquez pour t\u00e9l\u00e9charger ou glisser-d\u00e9poser",
"Climate": "Climat",
"Climate report": "Rapport sur le climat",
"Close": "Fermer",
"Co2 Certificates": "Certificats CO2",
"Code": "Code",
"Coming Soon": "Prochainement",
"Commission Price": "Prix de la commission",
"Commission Share": "Part de commission",
"Companies": "Entreprises",
"Companies for ": "Entreprises pour ",
"Companies for the corporate group: ": "Soci\u00e9t\u00e9s du groupe : ",
"Company": "Soci\u00e9t\u00e9",
"Company Authenticity number": "Num\u00e9ro d'authentification de l'entreprise",
"Company Name": "Nom de l'entreprise",
"Company No.": "N\u00b0 Soci\u00e9t\u00e9",
"Company Number": "Num\u00e9ro de soci\u00e9t\u00e9 (SIREN)",
"Company Roles": "R\u00f4les des entreprises",
"Company Users for ": "Utilisateurs de l'entreprise pour ",
"Company name": "Nom de l'entreprise",
"Company website": "Site web de la soci\u00e9t\u00e9",
"Compensation": "Compensation",
"Confirm Email Address": "Confirmer l'adresse courriel",
"Confirm Password": "Confirmer le mot de passe",
"Confirm Password is required": "La confirmation du mot de passe est requise",
"Confirm password does not match.": "La confirmation du mot de passe ne correspond pas.",
"Confirmation": "Confirmation",
"Congratulations, you\u2019ve chosen the best energy spending platform": "F\u00e9licitations, vous avez choisi la meilleure plateforme de d\u00e9penses \u00e9nerg\u00e9tiques",
"Consent": "Consentement",
"Consumption": "Consommation",
"Consumption (kWh)": "Consommation (kWh)",
"Consumption and CO\u2082e": "Consommation et CO\u2082e",
"Consumption is kWh": "La consommation est exprim\u00e9e en kWh",
"Consumption measured in kWh": "Consommation mesur\u00e9e en kWh",
"Contact Name": "Nom du contact",
"Contact Phone": "T\u00e9l\u00e9phone",
"Continue": "Continuer",
"Contract list": "Liste des contrats",
"Contracts": "Contrats",
"Conversion Rate": "Taux de conversion",
"Conversion Rate for CO\u2082e": "Taux de conversion pour le CO\u2082e",
"Conversion rate in g CO\u2082e/kWh": "Taux de conversion en g CO\u2082e/kWh",
"Copied to clipboard": "Copi\u00e9 dans le presse-papier",
"Corporate Group": "Groupe d'entreprises",
"Corporate Groups": "Groupes d'entreprises",
"Corporate Groups for the partner ": "Groupes d'entreprises pour le partenaire ",
"Corporate group and above level access": "Acc\u00e8s au niveau du groupe d'entreprises et au-del\u00e0",
"Cost": "Co\u00fbt",
"Cost (DKK)": "Co\u00fbt (DKK)",
"Cost in DKK": "Co\u00fbt en DKK",
"Country": "Pays",
"Country code": "Code du pays",
"Country, Timezone and Corporate Group is Required!": "Le pays, le fuseau horaire et le groupe d'entreprises sont obligatoires !",
"Create Historical Data Limit": "Cr\u00e9er une limite pour les donn\u00e9es historiques",
"Create New Contract": "Cr\u00e9er un nouveau contrat",
"Create a new password": "Cr\u00e9er un nouveau mot de passe",
"Create or get an API key to access your data.": "Cr\u00e9ez ou obtenez une cl\u00e9 API pour acc\u00e9der \u00e0 vos donn\u00e9es.",
"Created At": "Cr\u00e9\u00e9 le",
"Created By": "Cr\u00e9\u00e9 Par",
"Currency": "Devise",
"Currency is required": "Devise est requise",
"Current Password": "Mot de passe actuel",
"Current month only": "Mois en cours uniquement",
"Current year only": "Ann\u00e9e en cours uniquement",
"Customer": "Client",
"DKK": "DKK",
"Daily": "Quotidien",
"Danish": "Danois",
"Data Delivered By": "Donn\u00e9es fournies par",
"Data granularity. PT1H = every 1 hour, PT15M = every 15 minutes": "Granularit\u00e9 des donn\u00e9es. PT1H = toutes les 1 heures, PT15M = toutes les 15 minutes",
"Data is currently being loaded. Please hold on a moment.": "Les donn\u00e9es sont en cours de chargement. Veuillez patienter un instant.",
"Data validation - consumption": "Validation des donn\u00e9es - consommation",
"DataHub": "DataHub",
"Date": "Date",
"Date when the access is given": "Date \u00e0 laquelle l'acc\u00e8s est donn\u00e9",
"Day": "Jour",
"Day Report - Under development": "Rapport quotidien - En cours d'\u00e9laboration",
"Days": "Jours",
"Dear {{user_full_name}}": "Cher {{user_full_name}}",
"Dec": "D\u00e9c",
"Dec: Checking": "D\u00e9c. : V\u00e9rification",
"Dec: Get": "D\u00e9c : Obtenir",
"Dec: Update": "D\u00e9c : Mise \u00e0 jour",
"December": "D\u00e9cembre",
"Delete": "Supprimer",
"Delete API Key": "Supprimer la cl\u00e9 de l'API",
"Delete All Notifications": "Supprimer toutes les notifications",
"Deleted": "Supprim\u00e9",
"Description": "Description",
"Developer": "D\u00e9veloppeur",
"Did you forget your password? Create a new one by clicking the button below.": "Vous avez oubli\u00e9 votre mot de passe ? Cr\u00e9ez-en un nouveau en cliquant sur le bouton ci-dessous.",
"Did you get this email by mistake? If so no worries - you can just ignore it.": "Avez-vous re\u00e7u cet e-mail par erreur ? Si c'est le cas, ne vous inqui\u00e9tez pas, vous pouvez l'ignorer.",
"Difference": "Diff\u00e9rence",
"Discount Net Tariff": "Tarif net de r\u00e9duction",
"Discount Subscription": "Abonnement \u00e0 prix r\u00e9duit",
"Distribution": "Distribution",
"District Heating": "Chauffage urbain",
"Do you know?": "Connaissez-vous ?",
"Do you want to delete the document?": "Voulez-vous supprimer le document ?",
"Do you want to delete the historical data limit?": "Voulez-vous supprimer la limite des donn\u00e9es historiques ?",
"Do you want to delete the notification?": "Voulez-vous supprimer la notification ?",
"Do you want to unlink the company?": "Voulez-vous dissocier l'entreprise ?",
"Do you want to unlink the user?": "Voulez-vous dissocier l'utilisateur ?",
"Document Details": "D\u00e9tails du document",
"Document For": "Document pour",
"Document Preview": "Aper\u00e7u Document",
"Document Type": "Type de document",
"Document Uploading Failed": "\u00c9chec du t\u00e9l\u00e9chargement du document",
"Document deleted successfully": "Document supprim\u00e9 avec succ\u00e8s",
"Document list": "Liste des documents",
"Document not found": "Document non trouv\u00e9",
"Document updated successfully": "Document mis \u00e0 jour avec succ\u00e8s",
"Document uploaded successfully": "Document t\u00e9l\u00e9charg\u00e9 avec succ\u00e8s",
"Documents": "Documents",
"Don't Have An Account Yet?": "Vous n'avez pas encore de compte ?",
"Download": "T\u00e9l\u00e9charger",
"Download Climate Report": "T\u00e9l\u00e9charger le rapport sur le climat",
"Download Cost Report": "T\u00e9l\u00e9charger le rapport de co\u00fbts",
"Download Document": "T\u00e9l\u00e9charger le document",
"Download Energy Report": "T\u00e9l\u00e9charger le rapport sur l'\u00e9nergie",
"Download For App": "T\u00e9l\u00e9charger l'application",
"Download For WWW": "T\u00e9l\u00e9chargement pour WWW",
"Download Sport Price Report": "T\u00e9l\u00e9charger le rapport sur le prix du sport",
"Download report": "Rapport de t\u00e9l\u00e9chargement",
"Drag and drop files here or click": "Glissez-d\u00e9posez les fichiers ici ou cliquez",
"Drop the file here or": "D\u00e9posez le fichier ici ou",
"Dutch": "N\u00e9erlandais",
"EPAD": "EPAD",
"EPAD Price": "Prix de l'EPAD",
"EPAD Share": "Action EPAD",
"EPAD Type": "Type d'EPAD",
"EPAD kWh": "EPAD kWh",
"Edit": "Modifier",
"Edit Contract": "\u00c9diter Contrat",
"Edit Corporate Group": "Modifier le groupe d'entreprises",
"Edit Document Details": "Modifier les d\u00e9tails du document",
"Edit Feature": "Modifier la caract\u00e9ristique",
"Edit Historical Data Limit": "Modifier la limite des donn\u00e9es historiques",
"Edit Module": "\u00c9diter un module",
"Edit Partner": "Modifier le partenaire",
"Edit Role": "Modifier le r\u00f4le",
"Edit Subscription": "Modifier l'abonnement",
"Edit User": "Modifier l'utilisateur",
"Edit User Company": "Modifier l'entreprise de l'utilisateur",
"Effect Payment": "Paiement de l'effet",
"Effortless energy insights at your fingertips": "Des informations sur l'\u00e9nergie au bout des doigts",
"Ekskl. moms": "Hors TVA",
"Electricity": "\u00c9lectricit\u00e9",
"Electricity Charge": "Frais d'\u00e9lectricit\u00e9",
"Electricity consumption": "Consommation d'\u00e9lectricit\u00e9",
"Electricity measured in kWh": "\u00c9lectricit\u00e9 mesur\u00e9e en kWh",
"Email": "Courriel",
"Email Not Verified": "Envoyer Non v\u00e9rifi\u00e9",
"Email Sent ": "E-mail envoy\u00e9 ",
"Email address": "Adresse email",
"Email is required.": "Email est requis.",
"End": "Fin",
"End Date": "Date de fin",
"Energy": "\u00c9nergie",
"Energy Consumption (kWh)": "Consommation d'\u00e9nergie (kWh)",
"Energy Contract": "Contrat \u00e9nerg\u00e9tique",
"Energy Type": "Type d'\u00e9nergie",
"Energy report": "Bilan \u00e9nerg\u00e9tique",
"Energy type is required": "Le type d'\u00e9nergie est requis",
"English": "Anglais",
"Enter description": "Entrez la description",
"Enter email": "Entrez votre email",
"Enter email address": "Entrez une adresse email",
"Enter email address to continue.": "Vous pouvez continuer \u00e0 utiliser nos services. ",
"Enter full name": "Entrer le nom complet",
"Enter name": "Entrez le nom",
"Enter password": "Entrez le mot de passe",
"Enter password again": "Confirmer le mot de passe",
"Enter your new password to reset": "Entrez votre nouveau mot de passe pour r\u00e9initialiser",
"Error loading image:": "Erreur de chargement de l'image :",
"Error: Something went wrong!": "Erreur : Quelque chose n'a pas fonctionn\u00e9 !",
"Error: Something went wrong! ": "Erreur : Quelque chose n'a pas fonctionn\u00e9 ! ",
"Excel Reports": "Rapports Excel",
"Excel Update": "Mise \u00e0 jour Excel",
"Expire At": "Expire le",
"Export": "Exporter",
"Export to Excel": "Exporter vers Excel",
"Fabeke": "Fabeke",
"Fabeke Data": "Donn\u00e9es Fabeke",
"Fabeke follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.": "Fabeke suit une proc\u00e9dure standard d'utilisation de fichiers journaux. Ces fichiers enregistrent les visiteurs lorsqu'ils visitent les sites web. Toutes les soci\u00e9t\u00e9s d'h\u00e9bergement le font et cela fait partie des analyses des services d'h\u00e9bergement. Les informations collect\u00e9es par les fichiers journaux comprennent les adresses de protocole Internet (IP), le type de navigateur, le fournisseur d'acc\u00e8s Internet (FAI), la date et l'heure, les pages de renvoi et de sortie, et \u00e9ventuellement le nombre de clics. Ces donn\u00e9es ne sont pas li\u00e9es \u00e0 des informations personnellement identifiables. L'objectif de ces informations est d'analyser les tendances, d'administrer le site, de suivre les mouvements des utilisateurs sur le site et de recueillir des informations d\u00e9mographiques.",
"Fabeke's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.": "La politique de confidentialit\u00e9 de Fabeke ne s'applique pas aux autres annonceurs ou sites web. Nous vous conseillons donc de consulter les politiques de confidentialit\u00e9 respectives de ces serveurs publicitaires tiers pour obtenir des informations plus d\u00e9taill\u00e9es. Cela peut inclure leurs pratiques et des instructions sur la fa\u00e7on de refuser certaines options.",
"Failed to delete document": "\u00c9chec de la suppression du document",
"Failed to load document preview. Please try downloading the document.": "\u00c9chec du chargement de l'aper\u00e7u du document. Veuillez essayer de t\u00e9l\u00e9charger le document.",
"Failed to unlink. ": "\u00c9chec du d\u00e9couplage. ",
"Feature": "Caract\u00e9ristique",
"Feature Name": "Nom de la fonction",
"Feature key, Alpha numeric and dash only": "Touche de fonction, alphanum\u00e9rique et tiret uniquement",
"Features": "Caract\u00e9ristiques",
"Features for ": "Caract\u00e9ristiques ",
"Feb": "F\u00e9v",
"Feb: Checking": "F\u00e9v : V\u00e9rification",
"Feb: Get": "F\u00e9v : Obtenir",
"Feb: Update": "F\u00e9v : Mise \u00e0 jour",
"February": "F\u00e9vrier",
"Feel free to reach out to Customer Service. They are around 24/7 to help you.": "N'h\u00e9sitez pas \u00e0 contacter le service client\u00e8le. Il est disponible 24 heures sur 24 et 7 jours sur 7 pour vous aider.",
"File Name": "Nom du fichier",
"File type not supported": "Fichier non pris en charge",
"Fixed": "Fixe",
"Fixed Price": "Prix fixe",
"Fixed price": "Prix fixe",
"Fixed price ex epad": "Prix fixe ex epad",
"Fixed price ex epad and profile": "Prix fixe ex epad et profil",
"Fixed price ex profile": "Prix fixe ex profil",
"Fixed profile ex spot": "Profil fixe ex spot",
"For further information, please read CO2 emissions from Energistyrelsen: https://www.energidataservice.dk/tso-electricity/CO2Emis ": "Pour plus d'informations, veuillez consulter les \u00e9missions de CO2 publi\u00e9es par Energistyrelsen : https://www.energidataservice.dk/tso-electricity/CO2Emis ",
"Forgot Password": "Mot de passe oubli\u00e9",
"Forgot Your Password?": "Mot de passe oubli\u00e9 ?",
"Forgot your password?": "Mot de passe oubli\u00e9 ?",
"French": "Fran\u00e7ais",
"From": "De",
"From date is required": "La date de d\u00e9part est requise",
"Full Name": "Nom complet",
"Full Year": "Ann\u00e9e compl\u00e8te",
"Gain control of your energy spending": "Ma\u00eetrisez vos d\u00e9penses \u00e9nerg\u00e9tiques",
"Gas": "Gaz",
"Generate API Key": "G\u00e9n\u00e9rer une cl\u00e9 API",
"Generate Climate Report": "G\u00e9n\u00e9rer un rapport sur le climat",
"Generate Cost Report": "G\u00e9n\u00e9rer un rapport de co\u00fbts",
"Generate Email": "G\u00e9n\u00e9rer des courriels",
"Generate Energy Report": "G\u00e9n\u00e9rer un rapport sur l'\u00e9nergie",
"Generate Sport Price Report": "G\u00e9n\u00e9rer un rapport sur les prix dans le domaine du sport",
"Generating Excel file": "G\u00e9n\u00e9rer un fichier Excel",
"German": "Allemand",
"Get Full Visibility Over Your Energy Spending With Less Manual Work": "Obtenez une visibilit\u00e9 totale sur vos d\u00e9penses \u00e9nerg\u00e9tiques avec moins de travail manuel",
"Getting Data": "Obtenir des donn\u00e9es",
"Go to App": "Aller \u00e0 l'application",
"Green Certificates": "Certificats verts",
"Green Electricity": "\u00c9lectricit\u00e9 verte",
"Grid company": "Soci\u00e9t\u00e9 de r\u00e9seau",
"Heating": "Chauffage",
"Historical Data": "Historique des donn\u00e9es",
"Historical Data Limits": "Limites des donn\u00e9es historiques",
"Hour": "Heure",
"Hour Report - Under development": "Rapport horaire - En cours de d\u00e9veloppement",
"Hourly": "Toutes les heures",
"Hours": "Heures",
"House No.": "N\u00b0 de maison",
"How many buildings company have": "Combien de b\u00e2timents l'entreprise poss\u00e8de-t-elle ?",
"How many meters company have": "Combien de compteurs l'entreprise poss\u00e8de-t-elle ?",
"I agree with": "J'accepte",
"ID": "ID",
"If the data is heavy, it may still be loading.": "Si les donn\u00e9es sont lourdes, il se peut qu'elles soient encore en cours de chargement.",
"If you want to set no limit, add 999 in the numeric field. If you want to give no access, you can handle that in the subscription plan features. However, to implement this historical data limit, you must attach it to the subscription plan.": "Si vous ne souhaitez pas d\u00e9finir de limite, ajoutez 999 dans le champ num\u00e9rique. Si vous ne souhaitez accorder aucun acc\u00e8s, vous pouvez le faire dans les fonctionnalit\u00e9s du plan d'abonnement. Cependant, pour mettre en \u0153uvre cette limite de donn\u00e9es historiques, vous devez l'associer au plan d'abonnement.",
"InActive": "Inactif",
"Inkl. Moms": "Inkl. Mamans",
"Installation Numbers": "Num\u00e9ros d'installation",
"Installation number": "Num\u00e9ro d'installation",
"Installation number is required": "Le num\u00e9ro d'installation est requis",
"Internet connection restored": "Connexion Internet r\u00e9tablie",
"Interval": "Intervalle",
"Invite User": "Invite un ami",
"Invoice": "Facture",
"Invoices": "Factures",
"It appears that no company is associated with your account.": "Il semble qu'aucune entreprise ne soit associ\u00e9e \u00e0 votre compte.",
"It will download a zip file containing the PO and POT files. PO file will have the existing translations, and the POT file will have the latest text that requires translation. We can use the Poedit software to import the POT text into the PO file and translate it.": "Il t\u00e9l\u00e9chargera un fichier zip contenant les fichiers PO et POT. Le fichier PO contiendra les traductions existantes et le fichier POT contiendra le dernier texte \u00e0 traduire. Nous pouvons utiliser le logiciel Poedit pour importer le texte POT dans le fichier PO et le traduire.",
"Item": "Article",
"Items": "Articles",
"Jan": "Jan",
"Jan: Checking": "Jan : V\u00e9rification",
"Jan: Get": "Jan : Obtenir",
"Jan: Update": "Jan : Mise \u00e0 jour",
"January": "Janvier",
"Japanese": "Japonais",
"Jul": "Juil",
"Jul: Checking": "Jul : V\u00e9rification",
"Jul: Get": "Jul : Obtenir",
"Jul: Update": "Jul : Mise \u00e0 jour",
"July": "Juillet",
"Jun": "Juin",
"Jun: Checking": "Jun : V\u00e9rification",
"Jun: Get": "Jun : Obtenir",
"Jun: Update": "Jun : Mise \u00e0 jour",
"June": "Juin",
"Key": "Cl\u00e9",
"Key, Alpha numeric and dash only": "Touche, alpha num\u00e9rique et tiret uniquement",
"Kg of CO\u2082e": "Kg de CO\u2082e",
"Kilogram": "Kilogramme",
"LNG": "LNG",
"Language": "Langue",
"Languages": "Langues",
"Last Login": "Derni\u00e8re connexion",
"Last Run": "Derni\u00e8re ex\u00e9cution",
"Last date": "Derni\u00e8re date",
"Last seen": "Derni\u00e8re consultation",
"Like any other website, Fabeke uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.": "Comme tout autre site web, Fabeke utilise des \"cookies\". Ces cookies sont utilis\u00e9s pour stocker des informations, y compris les pr\u00e9f\u00e9rences des visiteurs et les pages du site Web auxquelles le visiteur a acc\u00e9d\u00e9 ou qu'il a visit\u00e9es. Ces informations sont utilis\u00e9es pour optimiser l'exp\u00e9rience des utilisateurs en personnalisant le contenu de nos pages web en fonction du type de navigateur des visiteurs et/ou d'autres informations.",
"Link": "Lien",
"Link User": "Lier l'utilisateur",
"Link company": "Entreprise de liaison",
"Link user": "Lier l'utilisateur",
"List View": "Vue en liste",
"List as": "Liste en tant que",
"Loading": "Chargement",
"Loading security verification...": "V\u00e9rification de la s\u00e9curit\u00e9 en cours...",
"Loading...": "Chargement...",
"Location": "Emplacement",
"Location and above level access": "Emplacement et acc\u00e8s au-dessus du niveau du sol",
"Login": "Connexion",
"Login as": "Connectez-vous comme",
"Login code": "Code de connexion",
"Login failed! Please try again": "La connexion a \u00e9chou\u00e9 ! Veuillez r\u00e9essayer",
"Login successful. Redirecting.": "Connexion r\u00e9ussie. Redirection en cours.",
"Login with your new password right away.": "Connectez-vous imm\u00e9diatement avec votre nouveau mot de passe.",
"Main Price Type": "Prix principal Type",
"Mandarin": "Mandarin",
"Mar": "Mar",
"Mar: Checking": "Mar : V\u00e9rification",
"Mar: Get": "Mar : Obtenir",
"Mar: Update": "Mar : Mise \u00e0 jour",
"March": "Mars",
"Mark As Read": "Marquer comme lu",
"Markup": "Marquage",
"Markup Price": "Prix major\u00e9",
"Markup Share": "Part de balisage",
"Max size supported 20MB": "Taille maximale prise en charge : 20 Mo",
"Maximum 50 symbols": "50 symboles au maximum",
"May": "Mai",
"May: Checking": "Mai : V\u00e9rification",
"May: Get": "Mai : Obtenir",
"May: Update": "Mai : Mise \u00e0 jour",
"Message": "Message",
"Meter": "M\u00e8tre",
"Meter No": "Num\u00e9ro de compteur",
"Meter and above level access": "Compteur et acc\u00e8s au niveau sup\u00e9rieur",
"Meter number": "Num\u00e9ro du compteur",
"Meter reading end date": "Date de fin du relev\u00e9 du compteur",
"Meter reading start date": "Date de d\u00e9but du relev\u00e9 du compteur",
"Minimum 3 symbols": "Au moins 3 symboles",
"Minimum Fee": "Frais minimums",
"Modals": "Popups",
"Module": "Module",
"Module code, Alpha numeric and dash only": "Code du module, alpha num\u00e9rique et tiret uniquement",
"Module name": "Nom du module",
"Moms": "M\u00e8res",
"Month": "Mois",
"Month Columns: Downloading": "Chroniques du mois : T\u00e9l\u00e9chargement",
"Month Columns: Processing": "Colonnes du mois : Traitement",
"Month Data: Downloading": "Donn\u00e9es mensuelles : T\u00e9l\u00e9chargement",
"Month Data: Processing": "Donn\u00e9es mensuelles : Traitement",
"Month Report - Under development": "Rapport mensuel - En cours d'\u00e9laboration",
"Monthly": "Mensuel",
"Monthly Statement": "D\u00e9claration mensuelle",
"Months": "Mois",
"Must be a valid email": "Doit \u00eatre un e-mail valide",
"My Account": "Mon compte",
"My Companies": "Mes Entreprises",
"My Profile": "Mon profil",
"Name": "Nom",
"Name is required.": "Le nom est requis.",
"Natural Gas": "Gaz naturel",
"Net": "Net",
"Net Tariff": "Tarif net",
"Never Login": "Ne jamais se connecter",
"New": "Nouveau",
"New Password": "Nouveau mot de passe",
"New Password is required": "Un nouveau mot de passe est requis",
"No": "Non",
"No Company": "Pas d'entreprise",
"No Documents Found": "Aucun document trouv\u00e9",
"No Historical Data Limit": "Aucune limite pour les donn\u00e9es historiques",
"No Limit": "Aucune limite",
"No Partner": "Pas de partenaire",
"No Results Found!": "Aucun r\u00e9sultat trouv\u00e9 !",
"No Rows": "Pas de rangs",
"No data found": "Aucune donn\u00e9e n'a \u00e9t\u00e9 trouv\u00e9e",
"No document available for preview": "Aucun document disponible pour pr\u00e9visualisation",
"No internet connection. Please check your network.": "Pas de connexion Internet. Veuillez v\u00e9rifier votre r\u00e9seau.",
"No option available": "Aucune option disponible",
"No use of Fabeke's logo or other artwork will be allowed for linking absent a trademark license agreement.": "Aucune utilisation du logo de Fabeke ou d'autres illustrations ne sera autoris\u00e9e pour l'\u00e9tablissement de liens en l'absence d'un accord de licence de marque.",
"Norwegian": "Norv\u00e9gien",
"Not Applicable": "Non Applicable",
"Not Cached": "Non en cache",
"Not Found": "Non trouv\u00e9",
"Notes": "Notes",
"Notification has been deleted": "La notification a \u00e9t\u00e9 supprim\u00e9e",
"Notification marked as read": "Notification marqu\u00e9e comme lue",
"Notifications": "Notifications",
"Nov": "Nov",
"Nov: Checking": "Nov : V\u00e9rification",
"Nov: Get": "Nov : Obtenir",
"Nov: Update": "Nov : Mise \u00e0 jour",
"November": "Novembre",
"Oct": "Oct",
"Oct: Checking": "Oct : V\u00e9rification",
"Oct: Get": "Oct : Obtenir",
"Oct: Update": "Oct : Mise \u00e0 jour",
"October": "Octobre",
"Official address of meter (not including location information)": "Adresse officielle du compteur (\u00e0 l'exclusion des informations relatives \u00e0 la localisation)",
"Often the number on company's bill": "Souvent le num\u00e9ro figurant sur la facture de l'entreprise",
"Oil": "P\u00e9trole",
"One Month Energy Consumption (kWh)": "Consommation d'\u00e9nergie sur un mois (kWh)",
"One Month Tariff (kWh)": "Tarif pour un mois (kWh)",
"Only PDF files are allowed.": "Seuls les fichiers PDF sont autoris\u00e9s.",
"Only PDF files are allowed. Leave empty to keep the existing file.": "Seuls les fichiers PDF sont autoris\u00e9s. Laissez ce champ vide pour conserver le fichier existant.",
"Only for system level users": "Uniquement pour les utilisateurs au niveau syst\u00e8me",
"Only lowercase alphanumeric characters and dashes are allowed": "Seuls les caract\u00e8res alphanum\u00e9riques minuscules et les tirets sont autoris\u00e9s",
"Order No": "Commande N\u00b0",
"Order Numbers": "Num\u00e9ros de commande",
"Others": "Autres",
"Overall statement": "D\u00e9claration g\u00e9n\u00e9rale",
"Parameter showing Electricity consumption": "Param\u00e8tre indiquant la consommation d'\u00e9lectricit\u00e9",
"Parent Company": "Soci\u00e9t\u00e9 m\u00e8re",
"Parent company and above level access": "Soci\u00e9t\u00e9 m\u00e8re et acc\u00e8s au niveau sup\u00e9rieur",
"Partner": "Partenaire",
"Partner Users for ": "Utilisateurs partenaires pour ",
"Partner and above level access": "Acc\u00e8s partenaire et niveaux sup\u00e9rieurs",
"Partners": "Partenaires",
"Partnerships Team": "L'\u00e9quipe des partenariats",
"Password": "Mot de passe",
"Password Changed": "Mot de passe modifi\u00e9",
"Passwords didn't match": "Les mots de passe ne correspondaient pas.",
"Period/Sum": "P\u00e9riode/Somme",
"Permissions": "Permissions",
"Permissions for ": "les autorisations pour ",
"Personal": "Personnel",
"Personal Information": "Informations personnelles",
"Please also note to calculate the emission rate from CO2, the 125% method is used, which means that coproduced heat is produced by a given efficiency by 125%.": "Veuillez \u00e9galement noter que pour calculer le taux d'\u00e9mission de CO2, la m\u00e9thode des 125 % est utilis\u00e9e, ce qui signifie que la chaleur coproduite est produite avec un rendement donn\u00e9 de 125 %.",
"Please authorize us on": "Veuillez nous autoriser sur",
"Please enter a valid email and password!": "Veuillez saisir une adresse e-mail et un mot de passe valides !",
"Please enter a valid email!": "Veuillez entrer une adresse email valide!",
"Please enter a valid password!": "Veuillez saisir un mot de passe valide !",
"Please select a file to upload": "Veuillez s\u00e9lectionner un fichier \u00e0 t\u00e9l\u00e9charger",
"Please wait": "Veuillez patienter",
"Please wait while security verification loads...": "Veuillez patienter pendant le chargement de la v\u00e9rification de s\u00e9curit\u00e9...",
"Price": "Prix",
"Price (cent/kWh)": "Prix (cent/kWh)",
"Price (pence/kWh)": "Prix (pence/kWh)",
"Price (\u00d8re/kWh)": "Prix (\u00d8re/kWh)",
"Price (\u00f8re/kWh)": "Prix (\u00f8re/kWh)",
"Price Price": "Prix Prix",
"Price Share": "Prix de l'action",
"Price Type": "Type de prix",
"Price elements": "\u00c9l\u00e9ments de prix",
"Price in (\u00d8re/kWh)": "Prix en (\u00d8re/kWh)",
"Price kWh": "Prix kWh",
"Price type": "Type de prix",
"Price type is required": "Le type de prix est requis",
"Prices": "Prix",
"Prices, tariffs, taxes and cost": "Prix, tarifs, taxes et co\u00fbts",
"Privacy Policy": "Politique de confidentialit\u00e9",
"Privacy Policy for Fabeke": "Politique de confidentialit\u00e9 de Fabeke",
"Procurement": "Approvisionnement",
"Profile": "Profil",
"Profile Price": "Prix du profil",
"Profile Share": "Profil de l'action",
"Profile Type": "Type de profil",
"Profile kWh": "Profil kWh",
"Q1": "Q1",
"Q2": "Q2",
"Q3": "Q3",
"Q4": "Q4",
"Quantity (kWh)": "Quantit\u00e9 (kWh)",
"Questions?": "Une question ?",
"Rabat Net Tariff": "Rabat Net Tariff",
"Read All Notifications": "Lire toutes les notifications",
"Read Notification": "Lire la notification",
"Ready to enhance your offering? Talk to someone from our partnerships team today & start using ": "Pr\u00eat \u00e0 am\u00e9liorer votre offre ? Parlez \u00e0 un membre de notre \u00e9quipe de partenariat d\u00e8s aujourd'hui et commencez \u00e0 utiliser les outils suivants ",
"Real-time, precise, and automated.": "En temps r\u00e9el, pr\u00e9cis et automatis\u00e9.",
"Recover Password": "R\u00e9cup\u00e9rer mot de passe",
"Registered successful. Redirecting.": "Enregistrement r\u00e9ussi. Redirection.",
"Remove file": "Supprimer le fichier",
"Report": "Rapport",
"Reports": "Rapports",
"Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.": "Demander \u00e0 une entreprise qui collecte les donn\u00e9es personnelles d'un consommateur de divulguer les cat\u00e9gories et les \u00e9l\u00e9ments sp\u00e9cifiques des donn\u00e9es personnelles qu'elle a collect\u00e9es sur les consommateurs.",
"Request that a business that sells a consumer's personal data, not sell the consumer's personal data.": "Demander qu'une entreprise qui vend les donn\u00e9es personnelles d'un consommateur ne vende pas les donn\u00e9es personnelles du consommateur.",
"Require all devices to sign in again with the new password.": "Exiger que tous les appareils se connectent \u00e0 nouveau avec le nouveau mot de passe.",
"Reset Completed": "R\u00e9initialisation termin\u00e9e",
"Reset Password": "R\u00e9initialiser le mot de passe",
"Reset Your Password": "R\u00e9initialisez votre mot de passe",
"Role": "R\u00f4le",
"Role Specific Information": "Informations sp\u00e9cifiques au r\u00f4le",
"Role key, Alpha numeric and dash only": "Cl\u00e9 de r\u00f4le, alpha num\u00e9rique et tiret uniquement",
"Roles": "R\u00f4les",
"Save": "Sauvegarder",
"Save All For": "Tout enregistrer pour",
"Save Changes": "Sauvegarder les changements",
"Save Profile": "Enregistrer profil",
"Saving. Please wait.": "Sauvegarde. Veuillez patienter.",
"Scraper List": "Liste des grattoirs",
"Scraper Log": "Grille de raclage",
"Scraper Name": "Nom du racleur",
"Search": "Rechercher",
"See All Notifications": "Voir toutes les notifications",
"Select": "S\u00e9lectionner",
"Select Company": "S\u00e9lectionnez une entreprise",
"Select date range": "S\u00e9lectionnez une p\u00e9riode",
"Select your locality": "S\u00e9lectionnez votre localit\u00e9",
"Send Link to Email": "Envoyer le lien par e-mail",
"Send the user a notification via email.": "Envoyer \u00e0 l'utilisateur une notification par courrier \u00e9lectronique.",
"Sep": "Sep",
"Sep: Checking": "Sep : V\u00e9rification",
"Sep: Get": "Sep : Obtenir",
"Sep: Update": "Sep : Mise \u00e0 jour",
"September": "Septembre",
"Settings": "R\u00e9glages",
"Setup a unique password to protect your account.": "Cr\u00e9ez un mot de passe unique pour prot\u00e9ger votre compte.",
"Share": "Partager",
"Share (%)": "Part (%)",
"Show up to": "Montrer \u00e0",
"Sign In": "Se connecter",
"Sign Out": "D\u00e9connexion",
"Sign Up": "S'inscrire",
"Sign in": "Se connecter",
"Sign up": "S'inscrire",
"Simple": "Simple",
"Spanish": "Espagnol",
"Spot (60%)": "Spot (60%)",
"Spot Premium Price": "Prix de la prime au comptant",
"Spot Premium Share": "Prime au comptant Action",
"Spot Price": "Prix au comptant",
"Spot Prices": "Prix au comptant",
"Spot premium": "Prime au comptant",
"Spotpris": "Spotpris",
"Start": "D\u00e9but",
"Start Date": "Date de d\u00e9but",
"Statement": "D\u00e9claration",
"Statement Export": "D\u00e9claration Export",
"Status": "Statut",
"Still Loading": "Toujours en cours de chargement",
"Street": "Rue",
"Submit": "Envoyer",
"Subscription": "Abonnement",
"Subscription Expire At": "Abonnement expirant le",
"Subscription Expired!": "Abonnement expir\u00e9!",
"Subscription Expiring Soon!": "Abonnement expirant bient\u00f4t !",
"Subscription Plan": "Plan d'abonnement",
"Subscription Plan Name": "Nom du plan d'abonnement",
"Subscription Plan added Successfully": "Plan d'abonnement ajout\u00e9 avec succ\u00e8s",
"Subscription Plans": "Plans d'abonnement",
"Subscription key, Alpha numeric and dash only": "Cl\u00e9 d'abonnement, alphanum\u00e9rique et tiret uniquement",
"Subscription updated Successfully": "Mise \u00e0 jour de l'abonnement r\u00e9ussie",
"Sum": "Somme",
"Sum/Average": "Somme/moyenne",
"Support": "Support",
"Swedish": "Su\u00e9dois",
"Switch as": "Interrupteur comme",
"System": "Syst\u00e8me",
"System Partners": "Partenaires syst\u00e8me",
"System Price": "Prix du syst\u00e8me",
"System Roles": "R\u00f4les syst\u00e8me",
"System Share": "Part du syst\u00e8me",
"System Tariff": "Tarif du syst\u00e8me",
"System Type": "Type de Syst\u00e8me",
"System Users": "Menus Utilisateurs",
"System kWh": "KWh du syst\u00e8me",
"TSO - System Subscription": "TSO - Abonnement au syst\u00e8me",
"Take control of your energy expenses with": "Ma\u00eetrisez vos d\u00e9penses \u00e9nerg\u00e9tiques avec",
"Tariff": "Nomenclature Produit",
"Tax": "Taxe",
"Taxes (\u00d8re/kWh)": "Taxes (\u00d8re/kWh)",
"Taxes in (\u00d8re/kWh)": "Taxes en (\u00d8re/kWh)",
"Tenants": "Locataires",
"Terms & Conditions": "Termes & Conditions",
"Test Climate Report": "Rapport sur le climat des essais",
"Test Energy Report": "Rapport sur l'\u00e9nergie des essais",
"Test Sport Price Report": "Test Sport Rapport de prix",
"Test report": "Rapport d'essai",
"Thank you for registering with us. We're excited to have you on board!": "Nous vous remercions de vous \u00eatre inscrit chez nous. Nous sommes ravis de vous compter parmi nous !",
"Thanks for signing up!": "Merci pour votre enregistrement!",
"That is great that you know that.": "C'est tr\u00e8s bien que vous le sachiez.",
"The POC has been updated.": "Le POC a \u00e9t\u00e9 mis \u00e0 jour.",
"The cache has been cleared": "Le cache a \u00e9t\u00e9 vid\u00e9",
"The calculations for the CO2 emissions are based on emissions from each power plant above 10MW and where all power plants below 10MW is regarded as one power plant. Furthermore, the calculations are based on production per hour, consumption per hour and exchange per hour.": "Les calculs des \u00e9missions de CO2 sont bas\u00e9s sur les \u00e9missions de chaque centrale \u00e9lectrique de plus de 10 MW et sur le fait que toutes les centrales \u00e9lectriques de moins de 10 MW sont consid\u00e9r\u00e9es comme une seule centrale \u00e9lectrique. En outre, les calculs sont bas\u00e9s sur la production par heure, la consommation par heure et l'\u00e9change par heure.",
"The company already linked.": "L'entreprise est d\u00e9j\u00e0 li\u00e9e.",
"The company has been linked.": "L'entreprise a \u00e9t\u00e9 reli\u00e9e.",
"The company has been unlinked.": "L'entreprise a \u00e9t\u00e9 dissoci\u00e9e.",
"The data limit has been updated": "La limite de donn\u00e9es a \u00e9t\u00e9 mise \u00e0 jour",
"The deal has updated": "L'accord a \u00e9t\u00e9 actualis\u00e9",
"The document has been uploaded.": "Le fichier a \u00e9t\u00e9 t\u00e9l\u00e9charg\u00e9.",
"The email has been sent": "L'email a \u00e9t\u00e9 envoy\u00e9",
"The file has been exported.": "Le fichier a \u00e9t\u00e9 export\u00e9.",
"The historical data limit has been added.": "La limite des donn\u00e9es historiques a \u00e9t\u00e9 ajout\u00e9e.",
"The mail already exists in the system!": "Le courrier existe d\u00e9j\u00e0 dans le syst\u00e8me !",
"The metering point id from datahub": "L'identifiant du point de mesure du datahub",
"The module has been updated": "Le module a \u00e9t\u00e9 mis \u00e0 jour",
"The new POC has been added.": "Le nouveau POC a \u00e9t\u00e9 ajout\u00e9.",
"The new deal has added": "Le nouvel accord a ajout\u00e9",
"The new feature has been added": "La nouvelle fonctionnalit\u00e9 a \u00e9t\u00e9 ajout\u00e9e",
"The new module has been added": "Le nouveau module a \u00e9t\u00e9 ajout\u00e9",
"The new partner has been added.": "Le nouveau partenaire a \u00e9t\u00e9 ajout\u00e9.",
"The new role has been added.": "Le nouveau r\u00f4le a \u00e9t\u00e9 ajout\u00e9.",
"The new user has been added.": "Le nouvel utilisateur a \u00e9t\u00e9 ajout\u00e9.",
"The partner has been updated.": "Le partenaire a \u00e9t\u00e9 mis \u00e0 jour.",
"The password has been reset.": "Le mot de passe a \u00e9t\u00e9 r\u00e9initialis\u00e9.",
"The password has been updated.": "Le mot de passe a \u00e9t\u00e9 mis \u00e0 jour.",
"The registration is by invitation only.": "L'inscription se fait uniquement sur invitation.",
"The role has been updated": "Le r\u00f4le a \u00e9t\u00e9 mis \u00e0 jour",
"The session has been expired.": "La session a expir\u00e9.",
"The system is now creating the report, and you can download it shortly by clicking Download.": "Le syst\u00e8me est en train de cr\u00e9er le rapport et vous pourrez le t\u00e9l\u00e9charger rapidement en cliquant sur T\u00e9l\u00e9charger.",
"The user already linked.": "L'utilisateur est d\u00e9j\u00e0 li\u00e9.",
"The user has been linked.": "L'utilisateur a \u00e9t\u00e9 reli\u00e9.",
"The user has been unlinked.": "L'utilisateur a \u00e9t\u00e9 dissoci\u00e9.",
"The user has been updated": "L'utilisateur a \u00e9t\u00e9 mis \u00e0 jour",
"The year cache has been updated": "Le cache de l'ann\u00e9e a \u00e9t\u00e9 mis \u00e0 jour",
"There are no documents matching your criteria.": "Aucun document ne correspond \u00e0 vos crit\u00e8res.",
"These terms and conditions outline the rules and regulations for the use of Fabeke's Website, located at https://www.fabeke.com": "Les pr\u00e9sentes conditions g\u00e9n\u00e9rales d\u00e9finissent les r\u00e8gles d'utilisation du site web de Fabeke, situ\u00e9 \u00e0 l'adresse https://www.fabeke.com",
"Third Party Privacy Policies": "Politiques de confidentialit\u00e9 des tiers",
"Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Fabeke, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.": "Les serveurs publicitaires tiers ou les r\u00e9seaux publicitaires utilisent des technologies telles que les cookies, le JavaScript ou les pixels invisibles utilis\u00e9s dans leurs publicit\u00e9s et liens respectifs qui apparaissent sur Fabeke et qui sont envoy\u00e9s directement au navigateur de l'utilisateur. Ils re\u00e7oivent automatiquement votre adresse IP lorsque cela se produit. Ces technologies sont utilis\u00e9es pour mesurer l'efficacit\u00e9 de leurs campagnes publicitaires et/ou pour personnaliser le contenu publicitaire que vous voyez sur les sites web que vous visitez.",
"This area is forbidden. Turn back now!": "Cette zone est interdite. Faites demi-tour imm\u00e9diatement !",
"This is a heads-up, everyone! We've temporarily paused new registrations. But don't worry, we'll open them again shortly. Stay tuned!": "Ceci est un avertissement pour tout le monde ! Nous avons temporairement interrompu les nouveaux enregistrements. Mais ne vous inqui\u00e9tez pas, nous les ouvrirons \u00e0 nouveau sous peu. Restez \u00e0 l'\u00e9coute !",
"Thumbnail View": "Affichage en vignettes",
"Time Zone": "Fuseau horaire",
"Timestamp of last encountered when requesting data from datahub": "Date de la derni\u00e8re rencontre lors de la demande de donn\u00e9es au datahub",
"Timezone": "Fuseau horaire",
"To": "\u00c0",
"To complete your registration and activate your account, please confirm your email address by clicking the below:": "Pour compl\u00e9ter votre inscription et activer votre compte, veuillez confirmer votre adresse e-mail en cliquant sur le lien ci-dessous :",
"To date is required": "La date de fin est requise",
"To ensure the data is tailored to your local time, we require your": "Afin de garantir que les donn\u00e9es soient adapt\u00e9es \u00e0 votre heure locale, nous avons besoin de votre",
"Total Electricity Charge": "Charge totale d'\u00e9lectricit\u00e9",
"Translation": "Traduction",
"Transmission Grid Tariff": "Tarif du r\u00e9seau de transport",
"Type": "Type",
"Type of meter. E17 = consumption, E18 = production": "Type de compteur. E17 = consommation, E18 = production",
"URL": "URL",
"Under construction": "Travaux en cours",
"Unit": "Unit\u00e9",
"Unknown Error Occurred !": "Une erreur inconnue s'est produite !",
"Unknown error1 Occurred !": "Erreur inconnue 1 survenue !",
"Unlink": "Dissocier",
"Update": "Mettre \u00e0 jour",
"Update Roles": "Mettre \u00e0 jour les r\u00f4les",
"Update failed": "Mise \u00e0 jour \u00e9chou\u00e9e",
"Update your Image and other data here.": "Mettez \u00e0 jour votre image et d'autres donn\u00e9es ici.",
"Updated At": "Mis \u00e0 jour le",
"Updating...": "Mise \u00e0 jour...",
"Upload": "T\u00e9l\u00e9verser",
"Upload Data": "Chargement de donn\u00e9es",
"Upload Document Files": "T\u00e9l\u00e9charger des fichiers documentaires",
"Upload New Document": "T\u00e9l\u00e9charger un nouveau document",
"Upload New Document File (Optional)": "T\u00e9l\u00e9charger un nouveau fichier (facultatif)",
"Upload PO file": "T\u00e9l\u00e9verser le fichier PO",
"Upload Po file": "T\u00e9l\u00e9charger le fichier Po",
"Uploaded": "Charg\u00e9",
"Uploading": "Chargement en cours",
"Uploading...": "T\u00e9l\u00e9chargement...",
"Use this page to update the application version. Once you change the version, the client-side application will automatically download and run the latest code from the server.": "Utilisez cette page pour mettre \u00e0 jour la version de l'application. Une fois la version modifi\u00e9e, l'application c\u00f4t\u00e9 client t\u00e9l\u00e9chargera et ex\u00e9cutera automatiquement le code le plus r\u00e9cent \u00e0 partir du serveur.",
"Used:": "Utilis\u00e9 :",
"User Data": "Donn\u00e9es d'utilisateur",
"User ID is missing": "L\u2019ID d\u2019utilisateur/utilisatrice est manquant",
"Users": "Utilisateurs",
"Users for the business: ": "Utilisateurs pour l'entreprise : ",
"Users for the corporate group: ": "Utilisateurs pour le groupe d'entreprises : ",
"V_per_m2": "V_per_m2",
"Validating period": "P\u00e9riode de validation",
"Validating. Please wait.": "Validation en cours. Veuillez patienter.",
"Validity end date": "Date de fin de validit\u00e9",
"Validity start date": "Date de d\u00e9but de validit\u00e9",
"Variable/Spot/Nordpool price": "Prix variable/Spot/Nordpool",
"Verification Successful": "V\u00e9rification r\u00e9ussie",
"Verify Password": "V\u00e9rifiez le mot de passe",
"Version": "Version",
"Version Management": "Gestion des versions",
"View": "Voir",
"View Mode": "Mode d'affichage",
"View meter details": "Voir les d\u00e9tails du compteur",
"Water": "Eau",
"We are unable to find your email address": "Nous ne parvenons pas \u00e0 trouver votre adresse \u00e9lectronique",
"We couldn't find what you searched for": "Nous n'avons pas trouv\u00e9 ce que vous cherchiez",
"We employ the use of cookies. By accessing Fabeke, you agreed to use cookies in agreement with the Fabeke's Privacy Policy.": "Nous utilisons des cookies. En acc\u00e9dant \u00e0 Fabeke, vous acceptez d'utiliser des cookies conform\u00e9ment \u00e0 la politique de confidentialit\u00e9 de Fabeke.",
"We have updated the reports for last month, and you can download the reports by clicking below": "Nous avons mis \u00e0 jour les rapports pour le mois dernier, et vous pouvez les t\u00e9l\u00e9charger en cliquant ci-dessous",
"Website": "Site web",
"Welcome to": "Bienvenue sur",
"Welcome to ": "Bienvenue \u00e0 ",
"What do you know?": "Qu'en savez-vous ?",
"Wrong password!": "Mauvais mot de passe!",
"Year": "Ann\u00e9e",
"Year Data: Downloading": "Donn\u00e9es annuelles : T\u00e9l\u00e9chargement",
"Year Data: Processing": "Donn\u00e9es annuelles : Traitement",
"Year Report - Under development": "Rapport annuel - En cours d'\u00e9laboration",
"Year: Get": "Ann\u00e9e : Obtenir",
"Year: Update": "Ann\u00e9e : Mise \u00e0 jour",
"Yearly": "Annuel",
"Years": "Ann\u00e9es",
"Yes": "Oui",
"Yes I know that.": "Oui, je le sais.",
"You are not authorized to perform this action": "Vous n\u2019\u00eates pas autoris\u00e9 \u00e0 effectuer cette action",
"You can change your password here": "Vous pouvez modifier votre mot de passe ici",
"You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browser's respective websites.": "Vous pouvez choisir de d\u00e9sactiver les cookies par le biais des options de votre navigateur. Pour obtenir des informations plus d\u00e9taill\u00e9es sur la gestion des cookies avec des navigateurs web sp\u00e9cifiques, vous pouvez consulter les sites web respectifs de ces navigateurs.",
"You can continue to use our services now. ": "Vous pouvez continuer \u00e0 utiliser nos services. ",
"You can now use your new password to sign in to your account.": "Vous pouvez maintenant utiliser votre nouveau mot de passe pour vous connecter \u00e0 votre compte.",
"You can upload only the PO file. After uploading that file, it takes almost 10 minutes to reflect the changes on the website.": "Vous ne pouvez t\u00e9l\u00e9charger que le fichier PO. Apr\u00e8s avoir t\u00e9l\u00e9charg\u00e9 ce fichier, il faut pr\u00e8s de 10 minutes pour que les changements soient r\u00e9percut\u00e9s sur le site web.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Vous avez \u00e9t\u00e9 invit\u00e9 par {{partner_name}} \u00e0 rejoindre {{role_name}}. Pour continuer, cliquez sur Connexion pour acc\u00e9der au syst\u00e8me.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Vous avez \u00e9t\u00e9 invit\u00e9 par le {{partner_name}} \u00e0 vous inscrire en tant que {{role_name}}. Pour continuer, vous devez cr\u00e9er un mot de passe pour acc\u00e9der au syst\u00e8me.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Vous avez \u00e9t\u00e9 invit\u00e9 par {{tenant_name}} \u00e0 rejoindre {{role_name}}. Pour continuer, cliquez sur Connexion pour acc\u00e9der au syst\u00e8me.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Vous avez \u00e9t\u00e9 invit\u00e9 par le {{tenant_name}} \u00e0 vous inscrire en tant que {{role_name}}. Pour continuer, vous devez cr\u00e9er un mot de passe pour acc\u00e9der au syst\u00e8me.",
"Your Picture": "Votre photo",
"Your account doesn\u2019t exist, please Sign Up": "Votre compte n'existe pas, veuillez vous inscrire",
"Your login session has been expired. Please log in again": "Votre session de connexion a expir\u00e9. Veuillez vous reconnecter",
"Your password has been changed": "Votre mot de passe a \u00e9t\u00e9 chang\u00e9",
"Your password has been successfully reset.": "Votre mot de passe a \u00e9t\u00e9 r\u00e9initialis\u00e9 avec succ\u00e8s.",
"Your private file": "Votre dossier priv\u00e9",
"Your profile has been updated": "Votre profil a \u00e9t\u00e9 mis \u00e0 jour",
"Your subscription has expired. Renew now to regain access to your account and all premium features.": "Votre abonnement a expir\u00e9. Renouvelez-le d\u00e8s maintenant pour retrouver l'acc\u00e8s \u00e0 votre compte et \u00e0 toutes les fonctionnalit\u00e9s premium.",
"Your subscription will expire in": "Votre abonnement expirera dans",
"Zip Code": "Code postal",
"aggregated": "agr\u00e9g\u00e9",
"all": "tout",
"and": "et",
"and Fabeke Tech does not take responsibility for any errors in submitted data and lists": "et Fabeke Tech n'est pas responsable des erreurs \u00e9ventuelles dans les donn\u00e9es et les listes soumises",
"browse": "parcourir",
"cache has been updated": "le cache a \u00e9t\u00e9 mis \u00e0 jour",
"clicking the link we just emailed you at ": "en cliquant sur le lien que nous venons de vous envoyer par courrier \u00e9lectronique ",
"collects your energy data, prices and carbon emissions from all relevant data sources and present your energy consumption, prices, taxes, costs, and carbon emissions in our energy spending platform.": "collecte vos donn\u00e9es \u00e9nerg\u00e9tiques, vos prix et vos \u00e9missions de carbone \u00e0 partir de toutes les sources de donn\u00e9es pertinentes et pr\u00e9sente votre consommation d'\u00e9nergie, vos prix, vos taxes, vos co\u00fbts et vos \u00e9missions de carbone sur notre plateforme de d\u00e9penses \u00e9nerg\u00e9tiques.",
"comprehensive data and insights": "des donn\u00e9es et des informations compl\u00e8tes",
"contact us": "contactez-nous",
"converts data into your language and local time zone": "convertit les donn\u00e9es dans votre langue et votre fuseau horaire local",
"country, timezone and corporate group": "pays, fuseau horaire et groupe d'entreprises",
"does not take responsibility for any errors in submitted data and lists": "n'assume aucune responsabilit\u00e9 pour les erreurs contenues dans les donn\u00e9es et listes soumises.",
"export": "Exporter",
"export to CSV": "exporter vers CSV",
"export to Excel": "exporter au format Excel",
"export to PDF": "Exporter au format PDF",
"files": "fichiers",
"for any queries.": "pour toute question.",
"g CO\u2082/kW": "g CO\u2082/kW",
"g CO\u2082e/kW": "g CO\u2082e/kW",
"gives you": "vous donne",
"https://www.example.com": "https://www.example.com",
"into your energy usage, costs, and carbon footprint.": "sur votre consommation d'\u00e9nergie, vos co\u00fbts et votre empreinte carbone.",
"kWh": "kWh",
"measuring the Carbon dioxide Consumption. potential difference across a surface area, we use the unit carbon dioxide per square meter (Co2/m2)": "pour mesurer la diff\u00e9rence de potentiel entre une surface et le dioxyde de carbone, on utilise l'unit\u00e9 dioxyde de carbone par m\u00e8tre carr\u00e9 (Co2/m2)",
"measuring the electrical potential difference across a surface area, we use the unit volts per square meter (V/m2)": "pour mesurer la diff\u00e9rence de potentiel \u00e9lectrique \u00e0 travers une surface, on utilise l'unit\u00e9 volts par m\u00e8tre carr\u00e9 (V/m2)",
"or": "ou",
"page": "page",
"q": "q",
"real-time, accurate insights": "des informations pr\u00e9cises en temps r\u00e9el",
"ubscription Expire A": "Abonnement expir\u00e9 A",
"v": "v"
},
"plural": "0"
}